"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.credentialStore = void 0;
const zustand_1 = require("zustand");
const middleware_1 = require("zustand/middleware");
const async_storage_1 = require("@react-native-async-storage/async-storage");
exports.credentialStore = zustand_1.default(middleware_1.persist((set) => ({
    docId: '',
    token: '',
    setToken: (token) => set((state) => (Object.assign(Object.assign({}, state), { token }))),
    setDocId: (docId) => set((state) => (Object.assign(Object.assign({}, state), { docId: docId }))),
    deleteEverything: () => set((state) => (Object.assign(Object.assign({}, state), { docId: '', token: '', expiresIn: '' }))),
    expiresIn: '',
    setExpiredIn: (exp) => set((state) => (Object.assign(Object.assign({}, state), { expiresIn: exp }))),
}), {
    name: 'docId-store',
    getStorage: () => {
        return async_storage_1.default;
    },
}));
//# sourceMappingURL=CredentialStore.js.map